import { getChannelCode } from "../pages/common/utils";

(function (document) {
  'use strict';

  const params = new URLSearchParams(window.location.search);

  if (params.has('code') && params.has('state') && (window.location.href.indexOf('#!/branch-loading') <= -1)) {
    const {
      origin,
      pathname,
      search
    } = window.location;
    let url = origin + pathname + search;
    safeRedirect(url);
  }


  if (window.location.href.endsWith('com.tr') || window.location.href.endsWith('com.tr/') || window.location.href.endsWith('dist/') || window.location.href.includes('CSOGENELSAKLAMA') || window.location.href.includes('CSOSAKLAMA') || window.location.href.includes('CSOKRIPTOTSAKLAMA')) {
    const { origin, pathname } = window.location;
    const baseUrl = origin + pathname;
    
    if (window.location.href.includes('CSOGENELSAKLAMA')) {
      localStorage.setItem("page", ' #!/public-general');
      if (!window.location.href.includes('CSOGENELSAKLAMA')) {
        window.location.href = baseUrl + `?lang=tr-TR&channelCode=CSOGENELSAKLAMA#!/public-general`;
      }
    } else if (window.location.href.includes('CSOKRIPTOTSAKLAMA')) {
      localStorage.setItem("page", ' #!/public-kripto-general');
      if (!window.location.href.includes('CSOKRIPTOTSAKLAMA')) {
        window.location.href = baseUrl + `?lang=tr-TR&channelCode=CSOKRIPTOTSAKLAMA#!/public-kripto-general`;
      }
    } else {
      localStorage.setItem("page", ' #!/');
      if (!window.location.href.includes('CSOSAKLAMA')) {
        window.location.href = baseUrl + `?lang=tr-TR&channelCode=CSOSAKLAMA#!/`;
      }
    }
  }

  // ===== SESSION DEBUG LOGGING (localStorage'a yazılır, sayfa yenilense bile kalır) =====
  // Production'da false yapılmalı
  const DEBUG_LOGGING_ENABLED = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const MAX_LOG_COUNT = 100; // Maksimum log sayısı
  
  function sessionLog(event, details, extra) {
    // Production'da sadece console'a yaz, localStorage'a yazma
    if (!DEBUG_LOGGING_ENABLED) {
      console.log('[SESSION]', event, details);
      return;
    }
    
    const logs = JSON.parse(localStorage.getItem('SESSION_DEBUG_LOGS') || '[]');
    
    // Tüm cookie'leri detaylı al
    let tokenInfo = null;
    let allCookies = {};
    try {
      document.cookie.split(';').forEach(c => {
        const [name, ...rest] = c.trim().split('=');
        if (name) {
          allCookies[name] = rest.join('=').substring(0, 50) + '...'; // İlk 50 karakter
        }
      });
      
      // ark-auth-cookie'yi parse et
      const authCookie = document.cookie.split(';').find(c => c.trim().startsWith('ark-auth-cookie='));
      if (authCookie) {
        const cookieValue = decodeURIComponent(authCookie.split('=')[1]);
        const parsed = JSON.parse(cookieValue);
        const now = new Date();
        const expAt = parsed.expirationAt ? new Date(parsed.expirationAt) : null;
        tokenInfo = {
          hasToken: !!parsed.accessToken,
          tokenLength: parsed.accessToken ? parsed.accessToken.length : 0,
          expirationAt: parsed.expirationAt,
          expirationIn: parsed.expirationIn,
          isExpired: expAt ? expAt < now : 'unknown',
          timeUntilExpiry: expAt ? Math.round((expAt - now) / 1000) + ' seconds' : 'unknown'
        };
      }
    } catch(e) {
      tokenInfo = { error: 'Parse error: ' + e.message };
    }
    
    const entry = {
      time: new Date().toISOString(),
      event: event,
      details: details || '',
      extra: extra || null,
      page: window.location.hash || '#',
      tokenInfo: tokenInfo,
      cookieCount: Object.keys(allCookies).length,
      cookieNames: Object.keys(allCookies)
    };
    logs.push(entry);
    // Maksimum log sayısını tut
    while (logs.length > MAX_LOG_COUNT) logs.shift();
    localStorage.setItem('SESSION_DEBUG_LOGS', JSON.stringify(logs));
    console.log('[SESSION DEBUG]', event, entry);
  }

  // ===== NETWORK İSTEKLERİNİ İZLE (401/403 hatalarını yakala) =====
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0]?.url || args[0];
    return originalFetch.apply(this, args)
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          sessionLog('API_AUTH_ERROR', `${response.status} error on ${url}`, {
            status: response.status,
            statusText: response.statusText,
            url: url
          });
        }
        return response;
      })
      .catch(error => {
        sessionLog('API_NETWORK_ERROR', `Network error on ${url}`, { error: error.message });
        throw error;
      });
  };

  // XMLHttpRequest'leri de izle
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._debugUrl = url;
    this._debugMethod = method;
    return originalXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      if (this.status === 401 || this.status === 403) {
        sessionLog('XHR_AUTH_ERROR', `${this.status} error on ${this._debugUrl}`, {
          status: this.status,
          method: this._debugMethod,
          url: this._debugUrl
        });
      }
    });
    return originalXHRSend.apply(this, arguments);
  };

  // ===== IDLE DETECTION (15 dakika boşta kalırsa logout) =====
  const IDLE_TIMEOUT_MS = 15 * 60 * 1000; // 15 dakika
  let lastActivityTime = Date.now();
  
  function updateLastActivity() {
    lastActivityTime = Date.now();
  }
  
  function getIdleTime() {
    return Date.now() - lastActivityTime;
  }
  
  function getIdleTimeSeconds() {
    return Math.round(getIdleTime() / 1000);
  }
  
  // Kullanıcı aktivitelerini dinle
  ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'].forEach(eventType => {
    document.addEventListener(eventType, updateLastActivity, { passive: true });
  });
  
  // İlk aktivite zamanını kaydet
  updateLastActivity();
  sessionLog('IDLE_DETECTION_INIT', `Idle timeout set to ${IDLE_TIMEOUT_MS / 60000} minutes`);
  
  // Idle durumunu kontrol et ve gerekirse logout yap
  function checkIdleTimeout() {
    // Login sayfasındayken idle check yapma
    if (window.location.hash.includes('branch-loading') || 
        window.location.hash.includes('public-') ||
        !window.location.hash.includes('branch-')) {
      return false;
    }
    
    // ark-auth-cookie yoksa zaten login değil, idle check yapma
    const authCookie = document.cookie.split(';').find(c => c.trim().startsWith('ark-auth-cookie='));
    if (!authCookie) {
      return false;
    }
    
    const idleTime = getIdleTime();
    const idleSeconds = Math.round(idleTime / 1000);
    
    if (idleTime >= IDLE_TIMEOUT_MS) {
      sessionLog('IDLE_TIMEOUT', `User idle for ${idleSeconds} seconds, logging out`);
      
      // Cookie'leri temizle (branch-loading-page'deki logout ile aynı)
      eraseCookie('LOGIN');
      eraseCookie('CUSTOMER_EMAIL');
      eraseCookie('CUSTOMER_NAME');
      eraseCookie('RECORD_TYPE');
      eraseCookie('POST_TYPE');
      eraseCookie('CLIENT_TYPE');
      eraseCookie('CLIENT_FIRM_CUSTOMER_NUM');
      eraseCookie('FROM_LOADING_PAGE');
      eraseCookie('LANGUAGE_CODE');
      eraseCookie('ark-auth-cookie');
      eraseCookie('selected-customer-number');
      eraseCookie('COMPANY_NAME');
      eraseCookie('IP_RESTRICTED');
      
      sessionLog('IDLE_LOGOUT_COOKIES_CLEARED', 'All session cookies cleared');
      
      // Login sayfasına yönlendir ve sayfayı yeniden yükle
      const channelCode = getChannelCode();
      let redirectUrl;
      if (channelCode === 'CSOKRIPTOTSAKLAMA') {
        redirectUrl = window.location.origin + window.location.pathname + '?lang=tr-TR&channelCode=CSOKRIPTOTSAKLAMA#!/branch-loading';
      } else if (channelCode === 'CSOGENELSAKLAMA') {
        redirectUrl = window.location.origin + window.location.pathname + '?lang=tr-TR&channelCode=CSOGENELSAKLAMA#!/branch-loading';
      } else {
        redirectUrl = window.location.origin + window.location.pathname + '?lang=tr-TR&channelCode=CSOSAKLAMA#!/branch-loading';
      }
      
      sessionLog('IDLE_LOGOUT_REDIRECT', `Redirecting to: ${redirectUrl}`);
      
      // Önce URL'i değiştir, sonra tam sayfa yenilemesi yap
      window.location.href = redirectUrl;
      // Hash değişikliği tam yenileme yapmaz, bu yüzden reload ekle
      setTimeout(() => {
        window.location.reload();
      }, 100);
      
      return true; // Idle timeout occurred
    }
    
    return false; // Still active
  }
  
  // Console'dan idle durumunu kontrol etmek için
  window.checkIdleStatus = function() {
    const idleSeconds = getIdleTimeSeconds();
    const remainingSeconds = Math.round((IDLE_TIMEOUT_MS - getIdleTime()) / 1000);
    console.log('⏱️ Idle Status:');
    console.log('   Boşta geçen süre:', idleSeconds, 'saniye (~' + Math.round(idleSeconds / 60) + ' dakika)');
    console.log('   Logout\'a kalan:', remainingSeconds > 0 ? remainingSeconds + ' saniye (~' + Math.round(remainingSeconds / 60) + ' dakika)' : 'TIMEOUT!');
    console.log('   Son aktivite:', new Date(lastActivityTime).toLocaleTimeString());
    return { idleSeconds, remainingSeconds, lastActivity: new Date(lastActivityTime) };
  };
  console.log('💡 Idle durumunu kontrol etmek için: checkIdleStatus()');

  // ===== GLOBAL ERROR HANDLER (split hatalarını yakala) =====
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('split')) {
      sessionLog('SPLIT_ERROR', event.message, {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        stack: event.error?.stack?.substring(0, 500)
      });
    }
  });

  // ===== VISIBILITY DEĞİŞİKLİĞİNİ İZLE (tab değişimi) =====
  document.addEventListener('visibilitychange', () => {
    sessionLog('VISIBILITY_CHANGE', document.hidden ? 'Tab hidden' : 'Tab visible');
  });

  // ===== SAYFA İÇİ GEÇİŞLERİ İZLE (hash routing) =====
  window.addEventListener('hashchange', () => {
    sessionLog('ROUTE_CHANGE', 'Navigated to: ' + window.location.hash);
  });

  // ===== PERİYODİK IDLE TIMEOUT KONTROLÜ (her 20 saniyede) =====
  // NOT: Token refresh işlemi ark-authentication-manager tarafından yapılıyor
  // Bu interval sadece idle timeout kontrolü için kullanılıyor
  setInterval(() => {
    try {
      // Idle timeout kontrolü yap
      checkIdleTimeout();
    } catch(e) {
      sessionLog('IDLE_CHECK_ERROR', 'Error checking idle timeout: ' + e.message);
    }
  }, 20000);

  // Logları temizlemek için: localStorage.removeItem('SESSION_DEBUG_LOGS')
  // Logları görmek için: JSON.parse(localStorage.getItem('SESSION_DEBUG_LOGS'))
  // Logları tablo olarak görmek için: console.table(JSON.parse(localStorage.getItem('SESSION_DEBUG_LOGS'))

  sessionLog('APP_LOADED', 'app.js initialized');
  
  addEventListener('authentication-login-success', () => {
    sessionLog('LOGIN_SUCCESS', 'User logged in');
    //if(readCookie('login') === null) {}

    // The above if structure has been deleted to redirect to the login page after authomatic logout.
    const { origin, pathname, search } = window.location;
    let url = origin + pathname + search;
    safeRedirect(url);
    window.location.reload();
    createCookie('LOGIN', true);
  })

  addEventListener('authentication-logout-success', () => {
    sessionLog('LOGOUT_SUCCESS', 'User logged out');
    console.log('logout successfull in custody management app');
    createCookie('LOGOUT', true);
    eraseCookie('LOGIN');
    //test token refresh
    const channelCode = getChannelCode();
    const url = new URL(window.location.href);
    url.searchParams.set('channelCode', channelCode);
    window.history.replaceState(null, null, url);
    const { origin, pathname, search } = window.location;
    let urlPrefix = origin + pathname + search;
    safeRedirect(urlPrefix);
    window.location.reload();
  })

  addEventListener('authentication-expired-session', () => {
    sessionLog('SESSION_EXPIRED', 'Token expired - this triggered the logout');
  })

  addEventListener('authentication-refresh-error', () => {
    sessionLog('REFRESH_ERROR', 'Token refresh failed - this triggered the logout');
  })

  addEventListener('authentication-request-invalid-token', () => {
    sessionLog('INVALID_TOKEN', 'Token invalid - this triggered the logout');
  })

  addEventListener('load', () => {
    sessionLog('PAGE_LOAD', 'Page loaded');
    eraseCookie('LOGOUT')
  })
  /* addEventListener('unload', ()=>{
     if(readCookie('LOGIN')){
          createCookie('LOGOUT', true);
          const rootPage = document.querySelector('branch-loading-page');
          const rootElement = rootPage.shadowRoot.querySelector('#authenticationManagerId');
          rootElement.requestLogout();
          const el = document.getElementById("cells-template-branch-loading")
          el.remove();   
     }
   })*/

  function createCookie(name, value, days) {
    var expires;

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    // Added secure flag and SameSite for better cookie handling
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/; secure; SameSite=Lax";
    console.log('[SESSION DEBUG] Cookie created:', name, '=', value);
  }

  function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ')
        c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name, "", -1);
  }

  function safeRedirect(url) {
    // Allow only relative paths or a whitelist of domains
    const allowedBase = window.location.origin;
    try {
      const parsed = new URL(url, allowedBase);
      if (parsed.origin === allowedBase) {
        window.location.href = parsed.href + '#!/branch-loading';
      } else {
        // Optionally, redirect to a safe default
        window.location.href = allowedBase + '/#!/branch-loading';
      }
    } catch (e) {
      // Invalid URL, redirect to a safe default
      window.location.href = allowedBase + '/#!/branch-loading';
    }
  }

  window.CellsPolymer.start({
    routes: {
      'public-personal': '/',
      'public-general': '/public-general',
      'public-kripto-general': '/public-kripto-general',
      'public-contact': '/public-contact',
      'public-security': '/public-security',
      'public-privacy': '/public-privacy',
      'public-kripto-documents': '/public-kripto-documents',
      'branch-assets': '/branch-assets',
      'branch-accounts': '/branch-accounts',
      'public-temporary': '/public-temporary',
      'public-online-application': '/public-online-application',
      'public-online-application-ok': '/public-online-application-ok',
      'public-kripto-get-password': '/public-kripto-get-password',
      'public-kripto-get-password-ok': '/public-kripto-get-password-ok',
      'public-cookie-policy': '/public-cookie-policy',
      'branch-loading': '/branch-loading',
      'branch-customers': '/branch-customers',
      'branch-products': '/branch-products',
      'branch-investments': '/branch-investments',
      'branch-history-assets': '/branch-history-assets',
      'branch-customer-detail': '/branch-customer-detail',
      'branch-transactions': '/branch-transactions',
      'branch-shipping-preference': '/branch-shipping-preference',
      'branch-change-password': '/branch-change-password',
      'branch-mobile-profile': '/branch-mobile-profile',
      'branch-kripto-assets': '/branch-kripto-assets',
      'branch-kripto-accounts': '/branch-kripto-accounts',
      'branch-kripto-transaction-history': '/branch-kripto-transaction-history',
      'branch-kripto-assets-detail': '/branch-kripto-assets-detail',
      'branch-kripto-transaction-confirm-or-cancel': '/branch-kripto-transaction-confirm-or-cancel',
      'branch-kripto-withdraw': '/branch-kripto-withdraw',
      'branch-kripto-withdraw-ok': '/branch-kripto-withdraw-ok',
      'branch-company-authorization': '/branch-company-authorization',
      'branch-wallet-addresses': '/branch-wallet-addresses',
      'branch-add-wallet-address': '/branch-add-wallet-address',
      'branch-edit-wallet-address': '/branch-edit-wallet-address',
      'branch-delete-wallet-address': '/branch-delete-wallet-address',
      'branch-approval-operations': '/branch-approval-operations',
      'branch-approval-detail': '/branch-approval-detail',
      'branch-kripto-whitelisted-ip': '/branch-kripto-whitelisted-ip',
      'branch-kripto-add-whitelisted-ip': '/branch-kripto-add-whitelisted-ip',
      'branch-kripto-edit-whitelisted-ip': '/branch-kripto-edit-whitelisted-ip',
      'branch-kripto-delete-whitelisted-ip': '/branch-kripto-delete-whitelisted-ip',
    },

  });

})(document);